import React from 'react';
import Male from '../assets/image/male3.png';
import Female from '../assets/image/female3.png';
import Ring from '../assets/image/cincin.png';

const ImageCouple = () => {
  return (
    <>
    <di className="grid justify-items-center mt-28 mx-10 text-center font-poppins lg:mx-52 lg:text-base text-sm">
    <span className="text-lg mb-4">
    Assalamu'alaikum Warahmatullahi Wabarakatuh. 
    </span>
    Untuk melaksanakan syariat agama-Mu, mengikuti sunnah rasul-Mu dalam membangun sebuah rumah tangga yang sakinah. Serta memiliki keturunan-keturunan shaleh dan shalehah yang senantiasa taat pada-Mu dan berbakti kepada orang tua, 
    Ya allah perkenankanlah kami merangkai jalinan kasih di bawah ridho mu.
    Mudahkanlah urusan kami dan berilah kami rizki serta anugerah-Mu yang nantinya bisa mengantarkan kami pada cita-cita dunia dan akhirat Mu ya Allah
    </di>
    <div id="catin" className="lg:flex justify-center mt-16 lg:mt-10">
        <div className="w-6/12 sm:w-4/12 lg:ml-44 my-10 mx-auto">
          <img src={Male} alt="..." className="shadow rounded-full lg:w-9/12 lg:h-64 max-w-full h-auto align-middle border-none" />
        </div>
        <div className="text-center text-base text-5xl font-Birthstone Bounce lg:mt-10 lg:mr-20">
          <div> 
            <span>
              Amar wirahadi kusuma
            </span>
            <div className="font-poppins text-xs mt-2">
              <span>
                Putra Ketiga dari Bpk.Wasjuri (رحمه الله) <br/> & ibu Nursiti
              </span>
            </div>
          </div>
          <div className="my-1 text-2xl my-7">Dengan</div>
          <div>
            <span>
            Marwiyah
            </span>
            <div className="font-poppins text-xs mt-2">
              <span>
                Putri Ketiga dari Bpk.Ahzannuri <br/> & ibu Ahzannuri
              </span>
            </div>
          </div>
        </div>
        <div className="w-6/12 sm:w-4/12 lg:mr-24 my-10 mx-auto">
          <img src={Female} alt="..." className="shadow rounded-full lg:w-9/12 lg:h-64 max-w-full h-auto align-middle border-none" />
        </div>
    </div>
    <div className="flex justify-center mb-24 mt-3">
       <img className="mx-auto w-24" alt="..." src={Ring} />
    </div>
    </>
  );
}

export default ImageCouple;